import dayjs from 'dayjs'
import { FC } from 'react'

import { getFormattedDate } from '@/utils/datetime'

type Props = {
  desiredDate: string
}

const ContentBlockDateStart: FC<Props> = ({ desiredDate }) => (
  <div>
    <p className="mb-4 font-bold text-grey-90 text-16">Дата посещения</p>

    <div className="flex items-center gap-32 sm:flex-col sm:items-start sm:gap-16">
      <div className="flex items-center gap-8">
        <p className="font-pro text-16">
          {dayjs(desiredDate).isToday()
            ? 'Сегодня'
            : getFormattedDate(desiredDate)}
        </p>
      </div>
    </div>
  </div>
)

export default ContentBlockDateStart
